import { Body } from '@lendi-ui/typography';

import { FIELD_PATHS } from '@funnels/constants';
import { BrokerInterviewsGuarantorEntityIndex } from '@funnels/types';

import { FunnelGrid, FunnelGridUnit } from '../../../Common';
import { CheckboxField } from '../../../Fields';

export const LenderSpecificBrokerDeclaration = ({
  brokerInterviewsGuarantorIndex,
}: BrokerInterviewsGuarantorEntityIndex) => {
  return (
    <FunnelGrid mt="md" mb="lg">
      <FunnelGridUnit size={1 / 2}>
        Broker declaration, complete once the guarantor has left:
        <ul>
          <li>
            <Body mb="sm">
              Advise the Guarantor that this information will now be used by ANZ as part of the final assessment of the
              loan application.
            </Body>
          </li>
          <li>
            <Body mb="sm">
              Advise the Guarantor that if this assessment by ANZ is successful, they will receive their Guarantee
              documents shortly.
            </Body>
          </li>
          <li>
            <Body mb="sm">
              Advise the Guarantor that if they wish to withdraw from this transaction before the funds are drawn, then
              they can do so and need to advise ANZ as soon as possible.
            </Body>
          </li>
          <li>
            <Body mb="sm">
              Advise the Guarantor that they must complete the applicable Customer Identification Process (CIP) at an
              ANZ Branch, if they have not done so already (ANZ cannot settle the loan until this requirement is met).
            </Body>
          </li>
        </ul>
      </FunnelGridUnit>
      <FunnelGridUnit size={1 / 2}>
        <CheckboxField
          name={FIELD_PATHS.BROKER_INTERVIEWS_GUARANTOR_HAS_LENDER_SPECIFIC_BROKER_DECLARATION(
            brokerInterviewsGuarantorIndex
          )}
          checkboxLabel="I confirm all this has now been completed"
          size="sm"
          isOptional
        />
      </FunnelGridUnit>
    </FunnelGrid>
  );
};
